import { apiGet } from "./client";
import type { ApiConfig } from "./client";

/** GET /groups: map of group key to group. */
export function getGroups<T = Record<string, any>>(config?: ApiConfig): Promise<T> {
  return apiGet<T>("/groups", config);
}
